import moment from 'moment'
/**
 * @param {String} timestamp    时间戳 
 * @param {String} format 	    时间格式
 * @param {String} unit 		    默认*1000 接受秒数
 * @param {String} def 		    	占位格式
 */
export function dateFormat(timestamp, format = 'YYYY-MM-DD HH:mm:ss', unit = 1000, def = "-") {
	if (!timestamp && def) {
		return def
	}
	return moment(timestamp * unit).format(format)
}



/**
 * @param {String} timestamp    时间戳 
 * @param {String} unit 		    默认*1000 接受秒数
 * @param {String} def 		    	占位格式
 */
export function sinceDate(timestamp, unit = 1000, def = "-") {
	if (!timestamp && def) {
		return def
	}
	return moment(timestamp * unit).fromNow()
}





/**
 * @param {String} str    			語言文字 
 * @param {String} lang 		    當前語言包key
 * @param {String} def 		    	失敗或者默認佔位
 */
export function langueageFormat(str, lang = 'zh-hk', def = '') {
	if (!str) {
		return def
	}

	if (typeof str === 'string') {
		try {
			const obj = JSON.parse(str);
			return obj[lang]
		} catch (e) {
			return def
		}
		// /對象
	} else {
		return str[lang] || def
	}




}